import { z } from 'zod';

export const colorSchema = z.object({
  key: z.string(),
  hex: z.string().regex(/^#([0-9a-fA-F]{6})$/),
  position: z.number().min(1),
  active: z.boolean(),
  capabilities: z.array(
    z.enum(['DTF', 'Digital', 'Sublimation', 'CupPrint', 'Flock', 'Flex'])
  ),
  id: z.number()
});
